const NATIONAL_HOLIDAYS_NORWAY = [
    '2026-01-01', // 1. nyttårsdag
    '2026-04-02', // Skjærtorsdag
    '2026-04-03', // Langfredag
    '2026-04-06', // 2. påskedag
    '2026-05-01', // Arbeiderenes dag
    '2026-05-14', // Kristi Himmelfartsdag
    '2026-05-17', // Grunnlovsdagen
    '2026-05-25', // 2. pinsedag
    '2026-12-24', // Julaften
    '2026-12-25', // 1. juledag
    '2026-12-26', // 2. juledag
    '2026-12-31', // Nyttårsaften
];
export function getDateTypeOfDay(selectedDay) {
    let date;
    try {
        if (!selectedDay || selectedDay.length === 0)
            throw new Error('Invalid date');
        date = new Date(selectedDay);
    }
    catch (error) {
        return 'day';
    }
    const dayOfWeek = date.getDay();
    if (dayOfWeek === 0 || dayOfWeek === 6) {
        return 'weekend';
    }
    if (NATIONAL_HOLIDAYS_NORWAY.includes(selectedDay)) {
        return 'holiday';
    }
    return 'day';
}
// Returns true if the time is 18:00 or later
export function getIsEvening(time) {
    const hour = parseInt(time?.split(':')[0], 10);
    return hour >= 18;
}
export function getDayTypeAndTimeOfDayFromSelectedTime(date, time) {
    const defaultResult = {
        typeOfDay: 'day',
        isEvening: false,
    };
    if (!date || date.length !== 10) {
        return defaultResult;
    }
    if (!time || time.length !== 5) {
        return defaultResult;
    }
    return {
        typeOfDay: getDateTypeOfDay(date),
        isEvening: getIsEvening(time),
    };
}
export const couldHaveSurcharge = (dayType, isEvening) => dayType !== 'day' || isEvening;
